import { render, staticRenderFns } from "./study-admins.vue?vue&type=template&id=40e549d4&scoped=true&"
import script from "./study-admins.vue?vue&type=script&lang=js&"
export * from "./study-admins.vue?vue&type=script&lang=js&"
import style0 from "./study-admins.vue?vue&type=style&index=0&id=40e549d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e549d4",
  null
  
)

component.options.__file = "study-admins.vue"
export default component.exports